export default __webpack_public_path__ + "static/video2-old-f9efd7ad54058562143dda2a15f31096.jpg";